export default "__VITE_ASSET__CAg4yNxN__"